import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

// STYLES
import { Icon, Typography } from '@mui/material';
import { ListItemStyled } from '../styles';

const MenuItem = props => {
  const { t } = useTranslation();
  const { data } = props;

  return (
    <ListItemStyled component={NavLink} to={data.route} key={data.label}>
      {!!data.icon && <Icon className="m-r-10">{data.icon}</Icon>}
      <Typography variant="body2" className="cut-text">
        {t(data.label)}
      </Typography>
    </ListItemStyled>
  );
};

MenuItem.propTypes = {
  data: PropTypes.object.isRequired,
};

export default React.memo(MenuItem);
